<template>
    <div id="confirm">
        <transition name="fade">
            <Loading v-if="isLoading" />
        </transition>
        <goTop />
        <step :stepNumber="4"/>
        <div class="content">
            <div class="container">
                <h2 class="title2">確認資料</h2>
                <h3 class="blueTitle">確認旅遊明細</h3>
                <div class="confirmList">
                    <p class="goCountry clarity-unmask">旅遊國家 :
                        <span>
                            台灣
                        </span>
                    </p>
                    <p class="goDate">旅遊期間 : <span class="clarity-unmask">{{ confirmData.startEndDateTime }}</span></p>
                </div>
                <h3 class="blueTitle">確認要保人資料</h3>
                <ul class="confirmList">
                    <li><span>身分證/居留證：</span><span class="tlf_n_l5 clarity-mask" id="confirmIdNo">{{ confirmData.applicantData.applicantIdNo }}</span></li>
                    <li><span>姓名：</span><span class="tlf_r_f1 clarity-mask wordBreakAll" id="confirmName">{{ confirmData.applicantData.applicantName }}</span></li>
                    <li><span>出生日期：</span><span class="tlf_n_dash1 clarity-mask" id="confirmBirth">{{ confirmData.applicantData.applicantBirthday }}</span></li>
                    <li><span>手機號碼：</span><span class="tlf_n_l4 clarity-mask" id="confirmTel">{{ confirmData.applicantData.applicantMobile }}</span></li>
                    <li><span>電子郵件：</span><span class="tlf_n_at1 clarity-mask" id="confirmEmail">{{ confirmData.applicantData.applicantEmail }}</span></li>
                    <li><span>職/行業別：</span><span class="clarity-mask">{{ confirmData.applicantData.applicantJob }}</span></li>
                    <li><span>居住地址：</span><span class="tlf_r_f6 clarity-mask" id="confirmAddress">{{ confirmData.applicantData.applicantFullAddress }}</span></li>
                </ul>
                <h3 class="blueTitle">確認被保人資料</h3>
                <div class="overFlowHidden">
                    <tabs class="insureTab" :options="{ useUrlFragment: false }">
                        <tab
                            :title="item.title"
                            v-for="(item, key) in confirmData.insureData"
                            :key="key"
                            :name="item.title"
                            :id="`rosterList-${key + 1}`"
                        >
                           <confirmDetail :insure="item" />
                        </tab>
                    </tabs>
                </div>
                <h3 class="blueTitle">總保費金額＆保單型式</h3>
                <div class="countArea">
                    <div>
                        <label class="checkbox">
                            <input type="checkbox" v-model="agreeSendEpolicy" disabled />
                            <div class="checkStyle clarity-unmask" ></div>
                            我瞭解本次投保提供電子保單
                        </label>
                        <p>( 寄送對象為要保人電子郵件：<span class="clarity-mask">{{ confirmData.applicantData.applicantEmail }} )</span></p>
                    </div>
                    <count :totalCount="confirmData.totalCount" :totalPremium="confirmData.totalPremium" :key="reloadCountKey"/>
                </div>

                <h3 class="blueTitle">同意聲明告知事項</h3>
                <div class="policyDiv clarity-unmask">
                    <div class="policyCon">
                        <h3 class="policyTitle active">本商品投保須知</h3>
                        <h3 class="policyTitle">本商品條款內容</h3>
                        <div class="policyText">
                            <div class="textCon" @scroll="onScroll">
                                <div id="policy1" class="policySection" v-html="policy1"></div><!--商品投保須知-->
                                <div id="policy2" class="policySection" v-html="policy2"></div><!--本商品條款內容-->
                            </div>
                        </div>
                    </div>
                    <p class="pinkText center pinkAlert">請滑動並詳閱條款所載完整內容</p>
                    <div class="policyCheck">
                        <label class="checkbox">
                            <input type="checkbox" v-model="agreePolicy" disabled>
                            <div class="checkStyle"></div> 我已詳閱並同意上述
                            <a class="link" :href="pdfURL" target="_blank">保單條款全文</a>
                        </label>
                        <label class="checkbox" v-if="have65YearOld">
                            <input type="checkbox" v-model="agree65Policy" disabled>
                            <div class="checkStyle"></div> 本人已充分瞭解此商品的特性及適合度，可正常處理日常事務及溝通，並願意投保。
                            <img src="../assets/question.svg" alt="" class="question" @click="policyPopup()">
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="btnArea">
            <div class="anotherBtn">
                <router-link :to="'/inform'" class="btn confirm_back_accu">返回</router-link>
                <a class="btn confirm confirm_go_accu" @click="checkConfirmPage">確定</a>
            </div>
        </div>
    </div>
</template>
<script setup>
        import goTop from "@/components/gotop.vue";
        import step from "@/components/step.vue";
        import confirmDetail from "@/components/confirm/confirm_detail.vue";
        import count from "@/components/count.vue";
        import LoadData from "@/utils/loadData";
        import { postApi } from "@/utils/callApi";
        import Loading from "@/components/loading.vue";
        import {popUp} from "@/utils/popUp";
        import {onMounted, ref , toRaw} from "vue";
        import gtm from "@/utils/gtmDataLayer";
        import Swal from 'sweetalert2'
        import {useRouter} from "vue-router";
        import apiConfig from "@/utils/apiConfig";
        import $ from "jquery"
        import moment from 'moment';

        const router = useRouter();
        let riskJobList = {};
        let jwtInfo = {};
        let policyType = "";
        const policy1 = ref({});//商品投保須知
        const policy2 = ref({});//本商品條款內容
        const pdfURL = ref("");
        let termsProductList = {}; //整理後的條款資料\
        const termsProduct =  ref([]);//CMS商品條款
        let insTraOrderId = sessionStorage.getItem("insTraOrderId");
        let pageStorage = JSON.parse(sessionStorage.getItem("pageStorage"));

        const isLoading = ref(false);
        const confirmData = ref({
            startEndDateTime: "",
            applicantData: {},
            insureData: [{
                "title": "",
                "insureIdNo": "",
                "insureName": "",
                "insureBirthday": "",
                "insureJob": "",
                "beneficiaryType": "",
                "rosterTotalPremium": 0,
                "travelAmount": 0,
                "harmMedicalAmount": 0,
                "buyUneasyPolicy": false,
                "buyOtherCostCompensation": false,
                "buyOverseaSickPolicy": false,
                "buyUrgencyHelp": false,
                "attention": null,
                "insureType": 1
            }],//給予預設，讓tab展開
            totalCount: 0,
            totalPremium: 0,
            countDays:0,
            referrerCode:""
        }
        );
        const have65YearOld = ref(false);
        const reloadCountKey = ref(0);
        const agreePolicy = ref(false);
        const agree65Policy = ref(false);
        const agreeSendEpolicy = ref(true);//固定只能勾選
        const planCode = ref("");

        //載入職行業清單
        const getRiskJobList = () => {
            LoadData.getRiskJobList(function (data) {
                riskJobList = data;
            });
        }

        //初始載入檢查登入
        const checkLogin = ()=>{
            var checkPage = true;
            var message = [];
            if (insTraOrderId === "" || insTraOrderId == null) {
                checkPage = false;
                message.push('流程錯誤，請重新投保');
            }
            if (jwtInfo == null) {
                checkPage = false;
                message.push('頁面逾期，請重新投保');
            }
            if (checkPage) {
                loadConfirmPage();
            } else {
                Swal.fire({
                    title: "頁面錯誤",
                    confirmButtonText: "確定",
                    showCloseButton: true,
                    html: '<img src="error.svg"><p>'+ message + '</p>',
                }).then(() => {
                    router.push('/');
                });
            }
        }

        //取得商品條款
        const getTermsProduct = () =>{
            const time = pageStorage.startDate.split('T')[0]; //CMS條款以投保起始日
            if(pageStorage)
                var data = {
                    "Term":[
                        {
                            "insCategory":"Travel",
                            "NoteType":[
                                5,6
                            ],
                            "InsTypes":
                                {
                                    'TF': time //TF是版本號 再加上投保期始時間
                                }
                        }
                    ]
                }
            postApi(apiConfig.CMSDomain , null, null, null, data)
                .then((response) => {
                    if (response.data.Code === 200) {
                        termsProduct.value = response.data.Data;
                        //取得個條款內容
                        policy1.value = termsProduct.value.find(terms => terms.NoteType === 5).Content; //網路投保須知
                        policy2.value = termsProduct.value.find(terms => terms.NoteType === 6).Content; //商品條款
                        pdfURL.value = termsProduct.value.find(terms => terms.NoteType === 6).PDFUrl; //商品條款檔案下載
                        tidyTerms();
                    } else {
                        //跳出錯誤
                        Swal.fire({
                            title: "載入錯誤",
                            confirmButtonText: "確定",
                            showCloseButton: true,
                            html: '<img src="error.svg"><p>條款載入錯誤</p>',
                        });
                    }
                })

        }
        const termsUpdate = () => { //條款瀏覽版控
            var termsData = {
                source: 'https://www.tmnewa.com.tw/ec/travel/overseas',
                terms: termsProductList
            }
            postApi(apiConfig.updateMemberTerms, jwtInfo.token, null, null, termsData)
                .then(() => {
                })
        }
        const tidyTerms = () =>{
            const termsProductApi = toRaw(termsProduct.value);
            termsProductList = termsProductApi.map((terms) =>{
                return {
                    id:terms.Id,
                    insures:terms.InsCategory,
                    cid:terms.NoteType,
                    publishDate: moment(terms.Date).format("YYYY-MM-DDTHH:mm:ss")
                }
            })
        }

        const loadConfirmPage = () => {
            var data = {
                'insTraOrderId': insTraOrderId,
            };
            jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
            postApi(apiConfig.getConfirmPage, jwtInfo.token, null, null, data)
                .then((response) => {
                    var getConfirmPageRes = response.data;
                    if (getConfirmPageRes.code === 200) {
                        confirmData.value.insureData = [];//載入時清空原本的預設
                        tidyConfirmData(getConfirmPageRes.data);
                        getTermsProduct();
                    } else {
                        Swal.fire({
                            title: "取得確認清單錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg"><p>'+ getConfirmPageRes.message + '</p>',
                        })
                    }
                })
                .catch(() => {
                    Swal.fire({
                        title: "取得確認清單錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        html: '<img src="error.svg"><p>檢查資料連線錯誤</p>'
                    })
                });
        }
        const tidyConfirmData = (response) => {
            let insureAlertList = "";
            confirmData.value.startEndDateTime = response.effDateTime.substring(0, 16) + ' ~ ' + response.expDateTime + ' 共' + response.insPeriod + '天';
            confirmData.value.totalPremium = response.totalPremium;
            confirmData.value.totalCount = response.insTraRosters.length;
            confirmData.value.applicantData = {
                applicantIdNo: response.applicantIdNo || null,
                applicantName: response.applicantName || null,
                applicantBirthday: response.applicantBirthday || null,
                applicantMobile: response.applicantMobile || null,
                applicantEmail: response.applicantEmail || null,
                applicantJob: getRiskJobText(response.applicantIoccup) || null,
                applicantFullAddress: response.applicantFullAddressNoZipCode || null,
            }
            confirmData.value.countDays = pageStorage.countDays;
            confirmData.value.referrerCode = pageStorage.referrerCode;

            response.insTraRosters.forEach((roster) => {
                const Birthday = moment().diff(moment(response.applicantBirthday), 'years');
                if(roster.insuredAge >= 65 || Birthday >= 65){
                    have65YearOld.value = true;
                }
                let user = roster.insuredName;
                const insure = {
                    title: user || null,
                    insureIdNo: roster.insuredIdNo || null,
                    insureName: roster.insuredName || null,
                    insureBirthday: roster.insuredBirthday || null,
                    insureJob: getRiskJobText(roster.insuredIoccup) || null,
                    beneficiaryType: getBeneficiaryTypeText(roster.beneficiaryType, roster.insTraBeneficiarys) || null,
                    rosterTotalPremium: roster.totalPremium || null,
                    travelAmount: roster.travelAmount || null,
                    harmMedicalAmount: roster.harmMedicalAmount || null,
                    buyUneasyPolicy: roster.buyRemarks.buyUneasyPolicy,
                    buyCarPolicy: roster.buyRemarks.buyCarPolicy,//汽車
                    buyMotorPolicy: roster.buyRemarks.buyMotorPolicy,//機車
                    buyTriathlon: roster.buyRemarks.buyTriathlon,//三鐵
                    buyTrafficAccident:  roster.buyRemarks.buyTrafficAccident,//交通意外
                    buyBurnPolicy:  roster.buyRemarks.buyBurnPolicy,//重大燒燙
                    attention: roster.insuredErrorMsg,
                    insureType:roster.rosterType || null
                }

                confirmData.value.insureData.push(insure);

                if(roster.insuredErrorMsg != null){
                    insureAlertList += '<div style="display: flex ;"><p class="overFlowHidden width30">'+roster.insuredName+ '</p> '+ ":" + roster.insuredErrorMsg + "</br></div>";
                }

            });
            sessionStorage.setItem("confirmPolicyType", response.policyType);//最終PolicyType
            sessionStorage.setItem("confirmPlanCode", response.planCode);//最終PolicyType
            policyType = response.policyType;
            planCode.value = response.planCode;

            if(insureAlertList !== ""){
                Swal.fire({
                    title: "請確認訊息內容",
                    showConfirmButton: false,
                    showCloseButton: true,
                    customClass: {container: "confirmAttention"},
                    html: '<img src="infomark.svg"><p>'+ insureAlertList + '</p>',
                })
            }
            reloadCountKey.value += 1;
        }
        const getBeneficiaryTypeText = (code, beneficiaryList) => {
            if (code !== "" && code != null) {
                var text = "";
                switch (code) {
                    case "1":
                        text = "法定繼承人";
                        break;
                    case "2":
                        var returnStr = "";
                        beneficiaryList.forEach((beneficiary, index) => {
                            if (index == 0) {
                                returnStr += beneficiary.beneficiaryName + "/" + getBeneficiaryRelationText(beneficiary.beneficiaryRelation)
                            } else {
                                returnStr += "、" + beneficiary.beneficiaryName + "/" + getBeneficiaryRelationText(beneficiary.beneficiaryRelation)
                            }
                        });
                        text = returnStr;
                        break;
                    default:
                        text = code;
                }
                return text;
            } else {
                return code;
            }
        }
        const getBeneficiaryRelationText = (code) => {
            if (code !== "" && code != null) {
                var text = ""
                switch (code) {
                    case "SPOUSE": text = "配偶"; break;
                    case "SIBLING": text = "兄弟姐妹"; break;
                    case "GRANDPARENT": text = "祖父母"; break;
                    case "PARENT": text = "父母"; break;
                    case "CHILD": text = "子女"; break;
                    case "GRANDCHILD": text = "孫子女"; break;
                    default: text = code; break;
                }
                return text;
            } else {
                return code;
            }
        }
        const getRiskJobText = (code) => {
            if (code !== "" && code != null) {
                var jobObject = riskJobList.find(job => job.jobCode === code);
                return jobObject.jobName;
            } else {
                return code;
            }
        }

        const onScroll = ({ target: { scrollTop, clientHeight, scrollHeight } }) =>{
            const $Div1 = document.getElementById('policy1').clientHeight
            const $Div2 = document.getElementById('policy2').clientHeight
            if (scrollTop >= $Div1) {
                $(".policyCon").find('h3').eq(1).addClass('active');
            }
            if (scrollTop >= $Div1 + $Div2-500) {
                $(".policyCon").find('h3').eq(1).addClass('active');
            }            if (scrollTop + clientHeight >= scrollHeight - 100) {
                $(".policyCheck").addClass("active").find("input[type='checkbox']").prop("disabled", false);
            }
        }
        const policyPopup = () =>{
            Swal.fire({
                title: "同意聲明告知事項",
                showConfirmButton: false,
                showCloseButton: true,
                customClass: {
                    container: "leftText",
                },
                text: "為保障65歲以上客戶辦理投保之權益，依據「保險業招攬及核保理賠辦法」第6條第1項第5款第5目之規定」，需再次確認要/被保險人已充分了解所投保之特性及適合度，如有任何對於保險商品不清楚可隨時與本公司客服專人聯絡。"
            });
        }
        const checkConfirmPage = () => {
            var checkFlag = true;

            if (!agreePolicy.value) {
                checkFlag = false;
            }
            if (have65YearOld.value) {
                if (!agree65Policy.value) {
                    checkFlag = false;
                }
            }

            if (checkFlag) {
                //checkConfirmPage
                isLoading.value = true;
                const data = {
                    'insTraOrderId': insTraOrderId,
                    'policySendType': "SOFT",//固定使用電子保單
                };
                jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
                postApi(apiConfig.checkConfirmPage, jwtInfo.token, null, null, data)
                    .then((response) => {
                        var checkConfirmPageRes = response.data;
                        if (checkConfirmPageRes.code === 200) {
                            sessionStorage.setItem('applicationNo', checkConfirmPageRes.data.applicationNo);
                            sessionStorage.setItem('confirmStorage', JSON.stringify(confirmData.value));
                            sessionStorage.setItem('otpType','confirm');
                            sendDataLayer(checkConfirmPageRes.data.applicationNo);
                            termsUpdate();
                            isLoading.value = false;
                            router.push("/otp");
                        } else {
                            Swal.fire({
                                title: "確認清單錯誤",
                                showConfirmButton: false,
                                showCloseButton: true,
                                html: '<img src="error.svg"><p>'+ checkConfirmPageRes.message + '</p>',
                            })
                            isLoading.value = false;
                        }
                    })
                    .catch(() => {
                        Swal.fire({
                            title: "確認清單錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg"><p>確認資料連線錯誤</p>',
                        })
                        isLoading.value = false;
                    });

            } else {
                Swal.fire({
                    title: "同意事項錯誤",
                    showConfirmButton: false,
                    showCloseButton: true,
                    html: '<img src="error.svg"><p>請確認同意聲明告知事項</p>',
                });
                isLoading.value = false;
            }

        }

        const sendDataLayer = (applicationNo)=>{
            gtm.policyEvent('begin_checkout', confirmData.value.totalPremium, applicationNo, null
                ,policyType, planCode.value, 'optional_taiwan', '自行試算');
        }

        getRiskJobList();
        checkLogin();

        onMounted(()=>{
            popUp();//公告系統
            gtm.pageViewEvent();//新增pageViewEvent

        });

</script>
<style lang="scss">
#confirm {
    font-size: 16px;
    color: $textColor;
    #inform #step::after {
        background-image: url("../assets/yellowBg.svg");
        background-size: 60%;
        background-repeat: no-repeat;
    }

    .confirmList {
        display: block;

        li {
            display: inline-block;
            width: 50%;
            vertical-align: top;
            margin: 10px 0;
            text-align: left;

            //span {
            //    font-weight: bold;
            //}

            .date {
                display: inline-block;
                vertical-align: top;
            }

            @media screen and (max-width: $small) {
                width: 100%;
            }
        }
    }

    .countArea .checkbox{
        cursor: default;
    }

    .countArea .checkbox+p {
        margin: 10px 0
    }

    .policyCheck {
        font-weight: 500;
        opacity: 0.3;
        transition: opacity 100ms ease-in-out;

        &.active {
            opacity: 1;
        }

        .checkbox {
            margin: 5px 0;
            a {
                color: $blue-700
            }
        }
    }

}
.text-red{
    color: red;
}
.text-p{
    line-height: 1.8;
    font-size: 0.6rem;
}
.textCon img{
    width: 100%;
}
.textCon h5{
    line-height: 1.8;
    margin: 0.2rem 0;
}
.column{
    display: flex;
    width: 100%;
    img{
        width: 100%;
    }
    h5{
        line-height: 1.8;
        margin: 0.2rem 0;
    }
    div{
        width: 48%;
        padding: 10px 1%;
        p{
            line-height: 1.6;
            font-size: 0.6rem;
        }
    }
}
.width30{
    max-width: 70px !important;
    min-width: 65px;
    margin: 0 !important;
}
.overFlowHidden .tabs-component-tab-a,.swal2-html-container .overFlowHidden{
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.confirmAttention .swal2-html-container{
    line-height: 30px;
    font-size:16px;
  text-align:left;
 img{display:block;margin:0 auto;}
}
.wordBreakAll{
    word-break: break-all;
}
</style>
